import * as actionTypes from '../../types/root';

const initialState = {
  data: {
    staff: [],
  },
  config: {
    export_formats: [],
  },
};

const root = (state = initialState, action) => {
  if (action.type.includes('GET_LIST_SUCCESS')) {
    return {
      ...state,
      data: {
        ...action.data,
        pagination: action.data.pagination || state.data.pagination,
      },
    };
  }

  if (action.type.includes('GET_CONFIG_SUCCESS')) {
    return {
      ...state,
      config: action.data,
    };
  }

  if (action.type === actionTypes.CLEAR_ROOT_STATE) {
    return {
      ...initialState,
    };
  }

  return state;
};

export default root;
